import { Box, styled } from '@mui/material';

export const EntityCalendarRightClickContainer = styled(Box)({
  display: 'contents'
});
